import React, { useContext } from 'react'

export const GameContext = React.createContext()

export const useGameData = () => useContext(GameContext)
